import { createFileRoute } from "@tanstack/react-router";
import {
  IndustryMarketingPage,
  industryMarketingHead,
  type IndustryFAQ,
} from "@/components/IndustryMarketingPage";

const FAQS: IndustryFAQ[] = [
  {
    q: "How do gyms and fitness studios get more members in Colorado?",
    a: "Local SEO + a tuned Google Business Profile + a 'free intro session' funnel. 'Gym near me', 'CrossFit Colorado Springs', and 'yoga studio Denver' are intent-heavy searches. Gyms that show up first in the Map Pack and convert with a low-friction trial offer fill their roster.",
  },
  {
    q: "Is Google Ads worth it for gyms?",
    a: "January absolutely — New Year resolutions triple search volume — and modestly in August (back-to-routine). Outside those windows, focus on SEO, referrals, and member retention. Year-round broad gym ads burn cash.",
  },
  {
    q: "What's the highest-ROI marketing channel for boutique studios?",
    a: "Reviews, referrals, and Instagram. Then SEO and Map Pack. Boutique fitness is a recommendation business — the marketing job is to make recommending you easy and to be findable when prospects search.",
  },
  {
    q: "Should I build a separate page for each class or program?",
    a: "Yes — yoga, Pilates, CrossFit, personal training, kids' classes all have separate search intent. Studios with per-program pages outconvert generic 'classes' pages 3–5x.",
  },
  {
    q: "Do you handle marketing for personal trainers and online coaches?",
    a: "Yes. Online coaching is a different beast — niche authority and content marketing matter more than local SEO. We build content engines and lead magnets for those models.",
  },
];

export const Route = createFileRoute("/gym-marketing-colorado")({
  head: () =>
    industryMarketingHead("Gym & Fitness Studio", "gym or fitness studio", "gym-marketing-colorado", FAQS),
  component: () => (
    <IndustryMarketingPage
      industry="Gym & Fitness Studio"
      industryLower="gym or fitness studio"
      slug="gym-marketing-colorado"
      subheadline="We help Colorado gyms, CrossFit boxes, yoga studios, and boutique fitness owners fill January, hold members through summer, and build a referral engine that compounds."
      painPoints={[
        "January resolutions fill you for 6 weeks and then attrition crushes the roster",
        "Your Map Pack ranking is buried under chain gyms that don't actually compete on programming",
        "Free-trial leads ghost — your intake funnel converts on a fraction of what it should",
      ]}
      serviceDescriptions={{
        seo: "Rank for gym, CrossFit, yoga, Pilates, personal training, and every class type across Colorado markets.",
        googleMaps: "Own the local Map Pack so 'gym near me' searches see your studio before the chains.",
        webDesign: "Conversion-first studio sites with frictionless trial offers, class schedules, and member testimonials.",
        ppc: "January and August Google Ads tuned to high-intent trial searches — no wasted summer spend.",
        geoAi: "Get cited when prospects ask ChatGPT 'best gym in Colorado Springs' or 'yoga studio near me'.",
        socialMedia: "Member-story content and Instagram funnels that drive referrals and trial signups.",
      }}
      testimonial={{
        quote:
          "We had our best January ever and held the members through summer. The trial-offer page converts at 4x our old funnel.",
        role: "Boutique Studio Owner",
        city: "Denver",
      }}
      faqs={FAQS}
      cityHubLinks={[
        { to: "/colorado-springs", label: "Gym & fitness marketing in Colorado Springs", description: "Fill studios across Briargate, downtown, and northern El Paso County." },
        { to: "/denver-digital-marketing", label: "Gym & fitness marketing in Denver", description: "Compete in Denver's saturated boutique fitness and CrossFit market." },
        { to: "/boulder-digital-marketing", label: "Gym & fitness marketing in Boulder", description: "Yoga, Pilates, and endurance training for Boulder's fitness-obsessed audience." },
      ]}
    />
  ),
});
